





















































































































import {Component, Vue} from "vue-property-decorator";
import {ECommerce} from "@/types/form/ECommerce";
import {Form} from "element-ui";
import {Action, Getter} from "vuex-class";
import {RSFORM_ACTION, RSFormActions} from "@/types/RSFormStore";
import {FormProps} from "@/types/form/FormProps";
import axios from "axios";
import {formatTimeRange} from "@/utils/formatTimeRange";
import {formatDate} from "@/utils/formatDate";
import {sub} from "date-fns";

@Component
export default class FormOne extends Vue {
  @Getter("rsForm/form") readonly rsForm!: FormProps;
  @Action(RSFORM_ACTION.UPDATE_RSFORM)
  updateRSForm!: RSFormActions["UPDATE_RSFORM"];

  @Action(RSFORM_ACTION.CLEAR)
  clear!: RSFormActions["CLEAR"];

  form: FormProps = {
    ec1: "",
    ec2: "",
    ec3: "",
    ec4: "",
    ec5: "",
    budget: null,
    startDate: null,
    endDate: null,
    brand: "",
    note: "",
  };

  pickerOptions = {
    disabledDate(time) {
      return time.getTime() < sub(Date.now(), {days: 1});
    },
  };

  windowHeight = document.body.clientWidth || 0;
  rules = {
    ec1: [{required: true, message: "請選擇電商", trigger: ["blur", "change"]}],
    budget: [{required: true, message: "請輸入預算金額", trigger: ["blur", "change"]}],
    startDate: [{required: true, message: "請選擇廣告預計開始時間", trigger: ["blur", "change"]}],
    endDate: [{required: true, message: "請選擇廣告預計結束時間", trigger: ["blur", "change"]}],
    brand: [{required: true, message: "請輸入預計投放之商品品牌", trigger: ["blur", "change"]}],
  };

  ec1 = "";
  ec2 = "";
  ec3 = "";
  ec4 = "";
  ec5 = "";

  eCommerces: ECommerce[] = [
    {label: "Carrefour家樂福線上購物", value: "Carrefour家樂福線上購物"},
    {label: "ETMall東森購物網", value: "ETMall東森購物網"},
    {label: "momo購物網", value: "momo購物網"},
    {label: "PChome 24h購物", value: "PChome 24h購物"},
    {label: "Rakuten樂天市場", value: "Rakuten樂天市場"},
  ];

  budgetList: string[] = [
    "NTD 300,000 以下",
    "NTD 300,001 ～ NTD 600,000",
    "NTD 600,001 ～ NTD 900,000",
    "NTD 900,001 以上",
  ];

  ecDescription =
    "請依各電商平台( Carrefour家樂福線上購物、ETMall東森購物網、momo購物網、PChome 24h購物、Rakuten樂天市場 ) 銷售額由大到小排序選擇您想預約的電商平台，並須確認您的商品有在該電商平台上架銷售。如未上架商品，可自行先與電商平台合作上架商品後再進行預約。";
  budgetDescription =
    "建議單一電商平台執行預算至少 NTD 30 萬台幣以上，如再新增一電商平台則為總預算金額建議為 NTD 60 萬台幣以上，以此類推。";
  dateRangeDescription = "請選擇廣告預計執行時間，建議至少執行一個月或以上。";
  brandDescription =
    "請確認您的商品是否有在上述所選的電商平台上架並銷售。如尚未上架商品，可自行先與電商平台討論商品上架事宜後再進行預約。";
  noteDescription = "如有其他問題，可於該欄位說明您的需求或疑問。";

  mounted(): void {
    window.addEventListener("resize", this.onResize);
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.onResize);
  }

  get ecOptionsOne(): ECommerce[] {
    return this.eCommerces;
  }

  get ecOptionsTwo(): ECommerce[] {
    return this.eCommerces.filter((ec) => this.ec1 !== ec.value);
  }

  get ecOptionsThree(): ECommerce[] {
    const selected = [this.ec1, this.ec2];
    return this.eCommerces.filter((ec) => selected.every((select) => select !== ec.value));
  }

  get ecOptionsFour(): ECommerce[] {
    const selected = [this.ec1, this.ec2, this.ec3];
    return this.eCommerces.filter((ec) => selected.every((select) => select !== ec.value));
  }

  get ecOptionsFive(): ECommerce[] {
    const selected = [this.ec1, this.ec2, this.ec3, this.ec4];
    return this.eCommerces.filter((ec) => selected.every((select) => select !== ec.value));
  }

  get labelPosition(): string {
    return this.windowHeight < 768 ? "top" : "left";
  }

  get displayDescription(): boolean {
    return this.windowHeight > 768;
  }

  get eCommerce() {
    const {ec1, ec2, ec3, ec4, ec5} = this;
    const ecArray = [ec1, ec2, ec3, ec4, ec5];
    const ecs = {};
    ecArray.forEach((ec, index) => {
      if (ec) {
        ecs[`ec${index + 1}`] = ec;
      }
    });
    return ecs;
  }

  combineEcToMail(ec1, ec2, ec3, ec4, ec5) {
    const ecArray = [ec1, ec2, ec3, ec4, ec5];
    return ecArray
      .filter((ec) => !!ec)
      .map((ec, index) => {
        const ecIndex = this.eCommerces.findIndex((ecData) => ecData.value === ec);
        return `${index + 1}. ${this.eCommerces[ecIndex].label}`;
      })
      .join(", ");
  }

  sendEmail(params): void {
    const {email, company, name, ec1, ec2, ec3, ec4, ec5, budget, startDate, endDate, brand, note} = params;
    const ecs = this.combineEcToMail(ec1, ec2, ec3, ec4, ec5);
    const msg = {
      to: email,
      date: formatDate(new Date(), "yyyy-MM-dd"),
      company,
      name,
      ecs,
      budget,
      startDate,
      endDate,
      brand,
      note,
    };
    axios
      .post(process.env.VUE_APP_MAIL_API_URL, msg)
      .then(() => console.log("success"))
      .catch(console.warn);
  }

  alertForEmail(): void {
    this.$alert("將跳轉至上一頁", "未輸入信箱", {
      confirmButtonText: "確定",
      callback: () => this.$router.push({name: "Form1"}),
    }).catch();
  }

  submit(): void {
    const {email} = this.rsForm;

    if (email === "") {
      this.alertForEmail();
      return;
    }

    (this.$refs["form2"] as Form).validate((valid) => {
      if (valid && this.form.startDate && this.form.endDate) {
        this.updateRSForm({...this.form, ec1: this.ec1, ec2: this.ec2, ec3: this.ec3, ec4: this.ec4, ec5: this.ec5});

        const {company, name, phone, email, jobTitle, ec1, ec2, ec3, ec4, ec5, budget, brand, note} = this.rsForm;

        const [startDate, endDate] = formatTimeRange([this.form.startDate, this.form.endDate]);
        const params = {
          company,
          name,
          phone,
          email,
          jobTitle,
          ec1,
          ec2,
          ec3,
          ec4,
          ec5,
          budget,
          startDate,
          endDate,
          brand,
          note,
        };

        this.sendEmail(params);
        const SheetsParams = {...params, created: formatDate(new Date(), "yyyy-MM-dd k:m:s")};
        axios
          .get(process.env.VUE_APP_SHEETS_API_URL, {
            params: SheetsParams,
          })
          .then(console.log)
          .catch(console.warn);

        (window as any).dataLayer.push({
          event: "submit",
          startDate,
          endDate,
          budget: budget,
          brand: brand,
          ...this.eCommerce,
        });
        this.clear();
        this.$router.push({name: "Form3"});
      }
    });
  }

  goBack(): void {
    this.$router.push({name: "Form1"});
  }

  onResize(): void {
    this.windowHeight = document.body.clientWidth || 0;
  }

  onSelectEcOne(ec: string): void {
    this.form.ec1 = ec;
    this.ec2 = "";
    this.ec3 = "";
    this.ec4 = "";
    this.ec5 = "";
  }

  onSelectEcTwo(): void {
    this.ec3 = "";
    this.ec4 = "";
    this.ec5 = "";
  }

  onSelectEcThree(): void {
    this.ec4 = "";
    this.ec5 = "";
  }

  onSelectEcFour(): void {
    this.ec5 = "";
  }
}
